import React, { useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, Hidden, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import InputIcon from '@material-ui/icons/Input';
import logo from '../../../../../logo_toolbar.png';
import { logout } from '../../../../../services/AuthApi';

const useStyles = makeStyles(theme => ({
    root: {
        boxShadow: 'none',
    },
    flexGrow: {
        flexGrow: 1,
    },
    signOutButton: {
        marginLeft: theme.spacing(1),
    },
}));

const Topbar = props => {
    const { className, onSidebarOpen, ...rest } = props;
    const history = useHistory();

    const classes = useStyles();

    const [notifications] = useState([]);

    const handleSair = () => {
        logout();
        history.push('/login');
        history.go();
    };

    return (
        <AppBar {...rest} className={clsx(classes.root, className)}>
            <Toolbar>
                <img
                    alt="Logo"
                    style={{
                        width: 121,
                        height: 47,
                        marginLeft: 34,
                        marginTop: 5,
                    }}
                    src={logo}
                />
                <div className={classes.flexGrow} />
                <Hidden smDown>
                    <IconButton
                        onClick={handleSair}
                        className={classes.signOutButton}
                        color="inherit"
                    >
                        <InputIcon />
                    </IconButton>
                </Hidden>
                <Hidden mdUp>
                    <IconButton color="inherit" onClick={onSidebarOpen}>
                        <MenuIcon />
                    </IconButton>
                </Hidden>
            </Toolbar>
        </AppBar>
    );
};

Topbar.propTypes = {
    className: PropTypes.string,
    onSidebarOpen: PropTypes.func,
};

export default Topbar;
